import { render, staticRenderFns } from "./DocumentIcon.vue?vue&type=template&id=0f62a758&"
import script from "./DocumentIcon.vue?vue&type=script&lang=ts&"
export * from "./DocumentIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports